export const TrackingNumberCarrierEnumValue = {
  None: 0,
  LTL: 10,
  Canpar: 20,
  Purolator: 30,
  Fedex: 40,
  UPS: 50,
  CanadaPost: 60,
};

export const TrackingNumberCarrierEnum = [
  {
    value: TrackingNumberCarrierEnumValue.LTL,
    labelFrench: 'Llt',
    labelEnglish: 'Ltl',
  },

  {
    value: TrackingNumberCarrierEnumValue.Canpar,
    labelFrench: 'Canpar',
    labelEnglish: 'Canpar',
  },

  {
    value: TrackingNumberCarrierEnumValue.Purolator,
    labelFrench: 'Purolator',
    labelEnglish: 'Purolator',
  },
  {
    value: TrackingNumberCarrierEnumValue.Fedex,
    labelFrench: 'FedEx',
    labelEnglish: 'FedEx',
  },
  {
    value: TrackingNumberCarrierEnumValue.UPS,
    labelFrench: 'UPS',
    labelEnglish: 'UPS',
  },
  {
    value: TrackingNumberCarrierEnumValue.CanadaPost,
    labelFrench: 'Poste Canada',
    labelEnglish: 'Canada Post',
  },
];

export default TrackingNumberCarrierEnum;
